import { useState } from "react";
import moment from "moment";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import DataTableDateTimePicker from "@/Layouts/components/DateTimePicker/DataTableDateTimePicker";
import { DATE_FORMAT } from "@/Constants/date";

interface InputEditDatetimeCellProps {
	id: string;
	field: string;
	startDate: string;
	endDate: string;
	error: boolean;
	type: "from" | "to";
	value: string;
	disabled: boolean;
	effectiveDateRangeFrom: string;
	effectiveDateRangeTo: string;
}

const InputEditDatetimeCell = (props: InputEditDatetimeCellProps) => {
	const apiRef = useGridApiContext();
	const { id, field, startDate, endDate, error, type, value, effectiveDateRangeFrom, effectiveDateRangeTo } = props;

	const [spiffDateValue, setSpiffDateValue] = useState(value ? moment.utc(value) : "");

	const minDate = () => {
		const date = moment(startDate);

		if (type === "to" && moment(effectiveDateRangeFrom).isValid()) {
			return moment(moment.max(moment.utc(effectiveDateRangeFrom), moment.utc(date))).toDate();
		}

		return moment(moment.utc(date)).toDate();
	};

	const maxDate = () => {
		const date = moment(endDate);

		if (type === "from" && moment(effectiveDateRangeTo).isValid()) {
			return moment.min(moment.utc(effectiveDateRangeTo), moment.utc(date)).toDate();
		}

		return moment.utc(date).toDate();
	};

	const onChangeHandle = (val: string | Date) => {
		apiRef.current.setEditCellValue({ id, field, value: moment(val), debounceMs: 200 });
		setSpiffDateValue(moment(val));
	};

	return (
		<DataTableDateTimePicker
			hideTabs
			minDateTime={minDate()}
			maxDateTime={maxDate()}
			onChange={onChangeHandle}
			value={spiffDateValue}
			disableIgnoringDatePartForTimeValidation
			disableHighlightToday
			views={["year", "month", "day"]}
			error={!moment(spiffDateValue).isValid() || error}
			format={DATE_FORMAT.monthAbbrDatePadded}
			disabled={props.disabled}
			viewRenderers={{
				hours: null,
				minutes: null,
				seconds: null,
			}}
			defaultCalendarMonth={moment(minDate())}
		/>
	);
};

export default InputEditDatetimeCell;
